import { create } from 'zustand';
import { UserAccessRights } from '@api/generated';
import { useAuthentication } from '@features/auth/useAuthentication.ts';

interface CurrentSalonState {
  currentSalon: UserAccessRights | null;
  setCurrentSalonId: (salon: string | null) => void;
}

/**
 * Single-salon model: the "current salon" is just the user's accessRights record
 * (which already encodes salonId, salonName, role and the canManage* flags).
 * The setter accepts an id for backwards compatibility but only resolves to the
 * single salon the user belongs to.
 */
export const useCurrentSalonStore = create<CurrentSalonState>(set => ({
  currentSalon: null,
  setCurrentSalonId: salonId => {
    if (!salonId) {
      set({ currentSalon: null });
      return;
    }
    const access = useAuthentication.getState().loggedUser?.accessRights;
    if (access && access.salonId === salonId) {
      set({ currentSalon: access });
    } else {
      // even if the URL salonId doesn't match (legacy multi-salon URLs),
      // fall back to the single accessRights record so the UI keeps working.
      set({ currentSalon: access ?? null });
    }
  },
}));
